export default __webpack_public_path__ + "static/media/tech3_2.e61a9883.png";